var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._b({attrs:{"false-value":0,"true-value":1,"hide-details":""},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},'v-checkbox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }